<template>
  <div v-show="isVisible">
    <v-text-field
      :label="schema.label || schema.title"
      :type="usesStringInput ? 'text' : 'number'"
      v-model="clampedValue"
      :placeholder="schema.placeholder"
      :rules="rules"
      :disabled="isDisabled"
      :class="fieldClasses"
      :min="schema.min"
      :max="schema.max"
      v-mask="formatInputProps.mask"
      :maxlength="formatInputProps.maxlength"
      :inputmode="formatInputProps.inputmode"
      @blur="$emit('blur')"
    />
  </div>
</template>

<script>
import GenericField from './GenericField';
import { safeMask } from '@/lib/safeMaskDirective';

export default {
  name: 'numberField',
  mixins: [GenericField],
  directives: { mask: safeMask },
  computed: {
    usesStringInput() {
      return Boolean(
        this.resolvedFormat ||
          this.formatInputProps.mask ||
          this.formatInputProps.inputmode === 'numeric'
      );
    },
    clampedValue: {
      get() {
        return this.localValue;
      },
      set(val) {
        if (this.usesStringInput) {
          this.localValue = val;
          return;
        }

        let num = Number(val);
        if (this.schema.min !== undefined && num < this.schema.min) {
          num = this.schema.min;
        }
        if (this.schema.max !== undefined && num > this.schema.max) {
          num = this.schema.max;
        }
        this.localValue = num;
      },
    },
  },
};
</script>
